<template>
  <div
    :style="section.styles.cssVariables.value"
    class="bg-(bg-default) text-(fg-default)"
    :class="[
      section.styles.spacerTop.value,
      section.styles.spacerBottom.value,
    ]"
  >
    <div
      class="container flex items-center gap-3 md:gap-10 min-h-[3.75rem]"
      :class="[
        section.styles.containerAlignment.value,
        `${!section.data?.value.shownElements?.logo || !section.data?.value.shownElements?.text ? 'justify-center' : 'justify-between'}`,
      ]"
    >
      <div
        v-if="section.data?.value.shownElements?.logo"
        class="inline-block"
        :class="[
          section.styles.boxedLogo.value,
        ]"
      >
        <img
          :src="`${useRuntimeConfig().public.imagekit}${useRuntimeConfig().public.imagekit ? '/tr:h-128,c-at_max/' : ''}${section.data?.value.logoSource}`"
          class="h-[2.125rem] w-auto object-contain"
          :alt="eventTitle"
        >
      </div>
      <div
        v-if="section.data?.value.shownElements?.text"
        class="inline-block [&_p]:mt-0 text-center md:text-left md:w-2/3"
        :class="{
          'md:text-right': props.data.arrangement === 'targetLeft',
          '!text-center': !section.data?.value.shownElements?.logo,
        }"
        v-html="sanitize(section.data?.value.text?.[section.lang.value]?.content)"
      />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
const section = usePageSection(props);

const eventTitle = inject('eventTitle');
</script>
